var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSchedularIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M4.9,6.1c0-0.2-0.2-0.4-0.4-0.4C4.2,5.7,4,5.9,4,6.1v15.5C4,21.8,4.2,22,4.4,22c0.2,0,0.4-0.2,0.4-0.4V6.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9,2H7.7v2.9H9V2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.3,2H15v2.9h1.3V2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.5,22c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-15C4.2,21,4,21.2,4,21.5C4,21.8,4.2,22,4.5,22H19.5z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20,6.1c0-0.3-0.2-0.5-0.5-0.5S19,5.9,19,6.1v15.4c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V6.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.6,4.1c0.8,0,1.4,0.6,1.4,1.4V7H4V5.6c0-0.8,0.6-1.4,1.4-1.4H18.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,12.7h6.7v7.1H11V12.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.3,8.4h4v4.3h-4V8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSchedularIcon);
export default __webpack_public_path__ + "static/media/Job-schedular-icon.4b9bcb9f8006ca66aae0c9c747a7f105.svg";
export { ForwardRef as ReactComponent };